/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./assessment-admin.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "@angular/router";
import * as i3 from "./assessment-admin.component";
var styles_AssessmentAdminComponent = [i0.styles];
var RenderType_AssessmentAdminComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AssessmentAdminComponent, data: {} });
export { RenderType_AssessmentAdminComponent as RenderType_AssessmentAdminComponent };
export function View_AssessmentAdminComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), i1.ɵdid(1, 212992, null, 0, i2.RouterOutlet, [i2.ChildrenOutletContexts, i1.ViewContainerRef, i1.ComponentFactoryResolver, [8, null], i1.ChangeDetectorRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_AssessmentAdminComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-assessment-admin", [], null, null, null, View_AssessmentAdminComponent_0, RenderType_AssessmentAdminComponent)), i1.ɵdid(1, 114688, null, 0, i3.AssessmentAdminComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AssessmentAdminComponentNgFactory = i1.ɵccf("app-assessment-admin", i3.AssessmentAdminComponent, View_AssessmentAdminComponent_Host_0, {}, {}, []);
export { AssessmentAdminComponentNgFactory as AssessmentAdminComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/admin/assessment-admin/assessment-admin.component.ngfactory.js.pre-build-optimizer.js